// extracted by mini-css-extract-plugin
export default {"wrapper":"dropdown_wrapper--GpeLi","menu":"dropdown_menu--MrVQv","scaleOnInit":"dropdown_scaleOnInit--Uttso","scaleOnClick":"dropdown_scaleOnClick--i4Gxg"};